import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';

@jsonObject
export class PublicBoxQuestionnaireFileResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly title!: string;

  @jsonMember(String)
  public readonly extension!: string;

  @jsonMember(String)
  public readonly url!: string;

  @jsonMember(String)
  public readonly alternativeText?: Nillable<string>;
}
